import { helper } from '@ember/component/helper';

import { minDate, maxDate } from 'rise-ui/config/time-series/query-params.js';

export default helper(function qpDateIsEternalHelper([ date, keyPos, dateFormat ], { key }) {
  if (Array.isArray(date)) {
    date = date[0];
  }
  return date && [].concat(key || keyPos || [ 'from', 'to' ]).every(key =>
    date[key] === minDate || date[key] === maxDate
  );
});
